"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "CookieBanner", {
    enumerable: true,
    get: function() {
        return _CookieBanner.default;
    }
});
const _CookieBanner = /*#__PURE__*/ _interop_require_default(require("./CookieBanner"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

//# sourceMappingURL=index.js.map